// extracted by mini-css-extract-plugin
export default {"statsList":"styles_stats-list__ZIkDU"};